<form [formGroup]="skjema" (ngSubmit)="send()" novalidate>
  <mat-toolbar color="primary">
    <span>{{ overskrift }}</span>
    <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty"></mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <div class="innhold">
      @if (status() === 'ikkesendt' || status()==='sender') {
        <mat-form-field >
          <mat-label>{{ "Beskjed inkludert i melding"|translate }}</mat-label>
          <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed"/>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'Send til ({antall} medlemmer)'|translate:{antall: skjema.value.mottakere!.length} }}</mat-label>
          <velg-medlemmer class="mottakere" [medlemmer]="valgbareMedlemmer" [skjemakontroll]="skjema.controls.mottakere!"></velg-medlemmer>
        </mat-form-field>

      }
      @if (status() === 'sendt') {
        <div class="sendt">
          @if (antallIkkeSendt() > 0) {
            <span>{{ 'E-post ble ikke sendt til:'|translate }}</span>
            <ul class="ikkeSendtTil">
              @for (medlem of medlemmerSomDetIkkeBleSendtTil(); track medlem.id) {
                <li>{{ medlem.navn }}: {{ medlem.epost }}</li>
              }
            </ul>
          }
          <span>{{
              '{antallSendt} av {totaltSomSkalSendes} e-poster sendt.'| translate:{
                antallSendt: antallSendt(),
                totaltSomSkalSendes: totaltSomSkalSendes()
              }
            }}</span>
        </div>
      }

      @if (status() === 'feilet') {
        {{ "Oops! Sending feilet! Sjekk hendelseslogg og se om noe er blitt sendt."|translate }}
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (status() === 'ikkesendt' || status() === 'sender') {
      <button mat-raised-button color="primary" type="submit" cdkFocusInitial
              [disabled]="skjema.invalid || status() === 'sender'"
              [visSpinner]="status() === 'sender'">{{ "Send" | translate }}
      </button>
      <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
    }
    @if (status() === 'sendt' || status() === 'feilet') {
      <button mat-raised-button color="primary" cdkFocusInitial mat-dialog-close>{{ "Lukk" | translate }}</button>
    }

  </mat-dialog-actions>

</form>
